import {
  AddCircleRounded,
  CheckBox,
  CheckBoxOutlineBlank,
  RemoveCircleRounded,
} from '@mui/icons-material';
import { IconButton, Typography } from '@mui/material';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCameraOverlayMutations } from '../hooks';
import { CameraIrisFocusControlsProps } from '../types';
import useCameraDetailsOverlayStyles from 'components/CameraDetailsOverlay/styles';
import { IRIS_SPEED } from 'components/CameraDetailsOverlay/constants';

const CameraIris: React.FunctionComponent<CameraIrisFocusControlsProps> = (props) => {
  const classes = useCameraDetailsOverlayStyles();
  const { t } = useTranslation(['video', 'common']);

  const { data, refetchData } = props;

  const { enableAutoIris, irisCamera } = useCameraOverlayMutations(data?.id, refetchData);

  return (
    <div className={classes.cameraControls}>
      <Typography
        variant='body1'
        fontSize='small'
        className={clsx(classes.controlText, classes.irisText)}
      >
        {t('common:iris')}
      </Typography>
      <div className={classes.controlsButtonsWrapper}>
        <IconButton size='small' onClick={() => irisCamera?.(data.id, -IRIS_SPEED)}>
          <RemoveCircleRounded className={classes.videoControllsButton} fontSize='small' />
        </IconButton>
        <IconButton size='small' onClick={() => irisCamera?.(data.id, IRIS_SPEED)}>
          <AddCircleRounded className={classes.videoControllsButton} fontSize='small' />
        </IconButton>
        {data.autoIrisEnabled ? (
          <IconButton onClick={() => enableAutoIris?.(data.id, false)} size='small'>
            <CheckBox className={classes.videoControllsButton} fontSize='small' />
          </IconButton>
        ) : (
          <IconButton onClick={() => enableAutoIris?.(data.id, true)} size='small'>
            <CheckBoxOutlineBlank className={classes.videoControllsButton} fontSize='small' />
          </IconButton>
        )}
        <Typography variant='body1' fontSize='small'>
          {t('common:auto')}
        </Typography>
      </div>
    </div>
  );
};

export default CameraIris;
